<template>
  <v-main style="margin: 0; padding: 0">
    <v-card flat class="poker-table">
      <v-card-text class="pa-0">

        <img class="poker-table-img" src="/static/imgs/poker-bg-rotated.png"/>

        <div class="hand-number" v-if="apiHand">
          <p class="mb-0">Hand <strong>#{{ apiHand.hand_seqno }}</strong></p>
          <p class="mb-0" v-if="apiHand.table_info">BB: ${{ apiHand.table_info.bb }}</p>

          <div class="board-cards" v-if="communityCards">
            <poker-card class="community-card" :card="card" v-for="card in communityCards" :key="card"></poker-card>
          </div>
        </div>

        <div v-if="apiHand">
          <poker-hand-player v-for="player of apiHand.players" :key="player.id"
            :player="getPlayer(player)"
          >
            {{ player }}
          </poker-hand-player>
        </div>
      </v-card-text>
    </v-card>
  </v-main>
</template>

<script>
import PokerHandPlayer from "./PokerHandPlayer";
import {mapGetters} from "vuex";
import PokerCard from "../PokerCard";
import { displayIDFromKey } from '@/plugins/store_updates';
export default {
  name: "PokerHand",
  props: ["hh"],
  components: {PokerCard, PokerHandPlayer},

  data() {
    return {
      RANKS: '__23456789TJQKA',
      SUITS: '_cdhs'
    }
  },

  mounted() {

  },

  computed: {
    apiHand() {
      if (!this.hh) return {};
      return this.hh.api_hand;
    },
    handSummary() {
      if (!this.hh) return {};
      if (!this.hh.raw_log) return {};
      return this.hh.raw_log.handSummary;
    },
    communityCards() {
      if (!this.hh) return [];
      return this.decodeCards(this.apiHand.communityCards);
    },
    activeDisplayID() {
      return displayIDFromKey(this.activeChatAccountName);
    },
    ...mapGetters([
      'activeChatAccountName',
    ])
  },

  methods: {

    getPlayer(player) {
      let result = this.apiHand.result.players_info.filter(el => el.playerId === player.id);
      let folded = this.apiHand.moves.filter(el => el.playerId === player.id && el.move === 0);

      let cards = this.decodeCards(player.cards);
      let showedCards = result[0].shown.length > 0;

      // add winners cards
      let winners = this.handSummary.winners;

      if (winners && winners.length) {
        for (let w of winners) {
          if (player.username === w.name) {
            cards = w.cards;
            break;
          }
        }
      }

      return {
        name: player.nickname,
        chips: player.startingAmount,
        cards: cards,
        showedCards: showedCards,
        seat: 'seat' in player ? player.seat : player.id,
        ourSeat: this.getOurSeat(),
        stack: result[0].stackAfterHand,
        result: result[0].result,
        folded: folded.length > 0,
        dealer: player.id === this.apiHand.players[0].id,
        gameType: this.hh ? this.hh.game_type : null,
      }
    },

    decodeCard(c) {
      return this.RANKS[c["rank"]] + this.SUITS[c["color"]];
    },

    decodeCards(cards) {
      return cards.map(el => this.decodeCard(el));
    },

    getOurSeat() {
      if (!this.apiHand) return -1;
      let players = this.apiHand.players.filter(el => el.nickname === this.activeDisplayID);
      if (!players.length) return -1;
      // for (let i = 0; i < this.apiHand.players.length; i++) {
      //   if (this.apiHand.players[i].nickname === this.activeChatAccountName) {
      //     return i;
      //   }
      // }
      // return -1;
      return 'seat' in players[0] ? players[0].seat : players[0].id;
    }
  }
}
</script>

<style scoped>
  .poker-table {
    width: 100%;

    overflow: visible;
  }

  .poker-table-img {
    width: 100%;
  }

  .board-cards {
    display: flex;
    margin-top: 10px;
    justify-content: center;
    height: 10%;
  }

  .community-card {
    margin-right: 5px;
    width: 6% !important;
  }

  .community-card >>> img {
    width: 100% !important;
  }

  .hand-number {
    position: absolute;

    font-size: 1.3em;

    height: 100%;

    flex-flow: column;

    z-index: 10;

    display: flex;
    align-items: center;
    justify-content: center;

    top: 0;
    left: 0;
    right: 0;

    margin: auto;

    color: white;
  }
</style>
